module.exports = __webpack_public_path__ + "static/media/5.Sprinkle Fittings.bd33e139.jpeg";